// Chemie Lernen — periodic-table portal for the Hubs client.
// Adds a fixed "Periodensystem" button that opens a modal periodic table.
// Clicking an element lists its chemie learning rooms (via the reticulum
// /hubs/element/:symbol API) and offers room creation.
import { createAndRedirectToNewHub } from "./utils/phoenix-utils";

// [number, symbol, name, group(1-18), period(1-7, 9=lanthanides, 10=actinides)]
const ELEMENTS = [
  [1, "H", "Wasserstoff", 1, 1], [2, "He", "Helium", 18, 1],
  [3, "Li", "Lithium", 1, 2], [4, "Be", "Beryllium", 2, 2], [5, "B", "Bor", 13, 2], [6, "C", "Kohlenstoff", 14, 2], [7, "N", "Stickstoff", 15, 2], [8, "O", "Sauerstoff", 16, 2], [9, "F", "Fluor", 17, 2], [10, "Ne", "Neon", 18, 2],
  [11, "Na", "Natrium", 1, 3], [12, "Mg", "Magnesium", 2, 3], [13, "Al", "Aluminium", 13, 3], [14, "Si", "Silicium", 14, 3], [15, "P", "Phosphor", 15, 3], [16, "S", "Schwefel", 16, 3], [17, "Cl", "Chlor", 17, 3], [18, "Ar", "Argon", 18, 3],
  [19, "K", "Kalium", 1, 4], [20, "Ca", "Calcium", 2, 4], [21, "Sc", "Scandium", 3, 4], [22, "Ti", "Titan", 4, 4], [23, "V", "Vanadium", 5, 4], [24, "Cr", "Chrom", 6, 4], [25, "Mn", "Mangan", 7, 4], [26, "Fe", "Eisen", 8, 4], [27, "Co", "Cobalt", 9, 4], [28, "Ni", "Nickel", 10, 4], [29, "Cu", "Kupfer", 11, 4], [30, "Zn", "Zink", 12, 4], [31, "Ga", "Gallium", 13, 4], [32, "Ge", "Germanium", 14, 4], [33, "As", "Arsen", 15, 4], [34, "Se", "Selen", 16, 4], [35, "Br", "Brom", 17, 4], [36, "Kr", "Krypton", 18, 4],
  [37, "Rb", "Rubidium", 1, 5], [38, "Sr", "Strontium", 2, 5], [39, "Y", "Yttrium", 3, 5], [40, "Zr", "Zirconium", 4, 5], [41, "Nb", "Niob", 5, 5], [42, "Mo", "Molybdän", 6, 5], [43, "Tc", "Technetium", 7, 5], [44, "Ru", "Ruthenium", 8, 5], [45, "Rh", "Rhodium", 9, 5], [46, "Pd", "Palladium", 10, 5], [47, "Ag", "Silber", 11, 5], [48, "Cd", "Cadmium", 12, 5], [49, "In", "Indium", 13, 5], [50, "Sn", "Zinn", 14, 5], [51, "Sb", "Antimon", 15, 5], [52, "Te", "Tellur", 16, 5], [53, "I", "Iod", 17, 5], [54, "Xe", "Xenon", 18, 5],
  [55, "Cs", "Cäsium", 1, 6], [56, "Ba", "Barium", 2, 6], [57, "La", "Lanthan", 3, 6], [72, "Hf", "Hafnium", 4, 6], [73, "Ta", "Tantal", 5, 6], [74, "W", "Wolfram", 6, 6], [75, "Re", "Rhenium", 7, 6], [76, "Os", "Osmium", 8, 6], [77, "Ir", "Iridium", 9, 6], [78, "Pt", "Platin", 10, 6], [79, "Au", "Gold", 11, 6], [80, "Hg", "Quecksilber", 12, 6], [81, "Tl", "Thallium", 13, 6], [82, "Pb", "Blei", 14, 6], [83, "Bi", "Wismut", 15, 6], [84, "Po", "Polonium", 16, 6], [85, "At", "Astat", 17, 6], [86, "Rn", "Radon", 18, 6],
  [87, "Fr", "Francium", 1, 7], [88, "Ra", "Radium", 2, 7], [89, "Ac", "Actinium", 3, 7], [104, "Rf", "Rutherfordium", 4, 7], [105, "Db", "Dubnium", 5, 7], [106, "Sg", "Seaborgium", 6, 7], [107, "Bh", "Bohrium", 7, 7], [108, "Hs", "Hassium", 8, 7], [109, "Mt", "Meitnerium", 9, 7], [110, "Ds", "Darmstadtium", 10, 7], [111, "Rg", "Roentgenium", 11, 7], [112, "Cn", "Copernicium", 12, 7], [113, "Nh", "Nihonium", 13, 7], [114, "Fl", "Flerovium", 14, 7], [115, "Mc", "Moscovium", 15, 7], [116, "Lv", "Livermorium", 16, 7], [117, "Ts", "Tenness", 17, 7], [118, "Og", "Oganesson", 18, 7],
  // Lanthanides (visual row 9)
  [58, "Ce", "Cer", 4, 9], [59, "Pr", "Praseodym", 5, 9], [60, "Nd", "Neodym", 6, 9], [61, "Pm", "Promethium", 7, 9], [62, "Sm", "Samarium", 8, 9], [63, "Eu", "Europium", 9, 9], [64, "Gd", "Gadolinium", 10, 9], [65, "Tb", "Terbium", 11, 9], [66, "Dy", "Dysprosium", 12, 9], [67, "Ho", "Holmium", 13, 9], [68, "Er", "Erbium", 14, 9], [69, "Tm", "Thulium", 15, 9], [70, "Yb", "Ytterbium", 16, 9], [71, "Lu", "Lutetium", 17, 9],
  // Actinides (visual row 10)
  [90, "Th", "Thorium", 4, 10], [91, "Pa", "Protactinium", 5, 10], [92, "U", "Uran", 6, 10], [93, "Np", "Neptunium", 7, 10], [94, "Pu", "Plutonium", 8, 10], [95, "Am", "Americium", 9, 10], [96, "Cm", "Curium", 10, 10], [97, "Bk", "Berkelium", 11, 10], [98, "Cf", "Californium", 12, 10], [99, "Es", "Einsteinium", 13, 10], [100, "Fm", "Fermium", 14, 10], [101, "Md", "Mendelevium", 15, 10], [102, "No", "Nobelium", 16, 10], [103, "Lr", "Lawrencium", 17, 10]
];

const STYLE = `
#chemie-pt-btn{position:fixed;right:18px;bottom:18px;z-index:99999;background:linear-gradient(135deg,#1e63b3,#00a3a3);color:#fff;border:none;border-radius:28px;padding:12px 20px;font:600 15px/1 system-ui,sans-serif;cursor:pointer;box-shadow:0 6px 20px rgba(0,0,0,.35)}
#chemie-pt-btn:hover{filter:brightness(1.08)}
#chemie-pt-overlay{position:fixed;inset:0;z-index:99998;background:rgba(6,18,32,.78);display:none;align-items:center;justify-content:center;padding:20px}
#chemie-pt-overlay.open{display:flex}
#chemie-pt-modal{background:#0b1f33;color:#eaf3ff;border-radius:14px;max-width:1100px;width:100%;max-height:92vh;overflow:auto;padding:18px 20px;box-shadow:0 20px 60px rgba(0,0,0,.5);font-family:system-ui,sans-serif}
#chemie-pt-modal h2{margin:0 0 4px;font-size:20px}
#chemie-pt-modal .sub{margin:0 0 14px;opacity:.7;font-size:13px}
#chemie-pt-close{float:right;background:none;border:none;color:#eaf3ff;font-size:22px;cursor:pointer;line-height:1}
#chemie-pt-grid{display:grid;grid-template-columns:repeat(18,minmax(30px,1fr));gap:4px}
.chemie-cell{background:#14395c;border:1px solid #1e63b3;border-radius:6px;padding:3px 2px;text-align:center;cursor:pointer;color:#eaf3ff;font-size:11px;line-height:1.15;min-height:38px;display:flex;flex-direction:column;justify-content:center}
.chemie-cell:hover{background:#1e63b3;transform:translateY(-1px)}
.chemie-cell .sym{font-weight:700;font-size:13px}
.chemie-cell .num{font-size:9px;opacity:.6}
.chemie-cell.f{background:#0d2e4a}
#chemie-pt-detail{margin-top:16px;padding:14px;border-top:1px solid #1e63b3}
#chemie-pt-detail h3{margin:0 0 8px}
#chemie-pt-rooms{list-style:none;padding:0;margin:8px 0}
#chemie-pt-rooms li{padding:6px 0;border-bottom:1px solid #14395c}
#chemie-pt-rooms a{color:#7ec8ff;text-decoration:none}
#chemie-pt-rooms a:hover{text-decoration:underline}
.chemie-pt-create{margin-top:10px;background:#00a3a3;color:#04222a;border:none;border-radius:8px;padding:10px 16px;font-weight:600;cursor:pointer}
.chemie-pt-create:hover{filter:brightness(1.08)}
.chemie-pt-msg{opacity:.8;font-size:13px}
`;

function buildTable() {
  const grid = document.createElement("div");
  grid.id = "chemie-pt-grid";
  for (const [, symbol, name, group, period] of ELEMENTS) {
    const cell = document.createElement("div");
    cell.className = "chemie-cell" + (period >= 9 ? " f" : "");
    cell.style.gridColumn = String(group);
    cell.style.gridRow = String(period);
    cell.innerHTML = `<span class="num"></span><span class="sym">${symbol}</span><span>${name}</span>`;
    cell.title = name;
    cell.addEventListener("click", () => showElement(symbol, name));
    grid.appendChild(cell);
  }
  return grid;
}

async function showElement(symbol, name) {
  const detail = document.getElementById("chemie-pt-detail");
  detail.innerHTML = `<h3>${name} (${symbol})</h3><p class="chemie-pt-msg">Lade Räume…</p>`;
  const createBtn = document.createElement("button");
  createBtn.className = "chemie-pt-create";
  createBtn.textContent = `Neuen „${name}-Raum“ erstellen`;
  createBtn.addEventListener("click", () => createAndRedirectToNewHub(name + "-Raum", null, true, null, { chemistry: { symbol: symbol, name: name } }));
  detail.appendChild(createBtn);
  try {
    const res = await fetch(`/api/v1/hubs/element/${symbol.toLowerCase()}`);
    const data = await res.json();
    const hubs = (data && data.hubs) || [];
    const list = document.createElement("ul");
    list.id = "chemie-pt-rooms";
    if (hubs.length === 0) {
      detail.insertAdjacentHTML("beforeend", `<p class="chemie-pt-msg">Noch keine Räume für ${name}. Erstelle den ersten!</p>`);
    } else {
      for (const h of hubs) {
        const li = document.createElement("li");
        const a = document.createElement("a");
        a.href = "/hub/" + h.hub_id + "/" + (h.slug || "");
        a.textContent = h.name || h.hub_id;
        a.target = "_blank";
        li.appendChild(a);
        list.appendChild(li);
      }
      detail.insertAdjacentHTML("beforeend", `<p class="chemie-pt-msg">${hubs.length} Raum/Räume:</p>`);
      detail.appendChild(list);
    }
  } catch (e) {
    detail.insertAdjacentHTML("beforeend", `<p class="chemie-pt-msg">Räume konnten nicht geladen werden.</p>`);
  }
}

function init() {
  if (document.getElementById("chemie-pt-btn")) return;
  const style = document.createElement("style");
  style.textContent = STYLE;
  document.head.appendChild(style);

  const btn = document.createElement("button");
  btn.id = "chemie-pt-btn";
  btn.textContent = "🧪 Periodensystem";
  document.body.appendChild(btn);

  const overlay = document.createElement("div");
  overlay.id = "chemie-pt-overlay";
  overlay.innerHTML = `
    <div id="chemie-pt-modal">
      <button id="chemie-pt-close" title="Schließen">×</button>
      <h2>Periodensystem der Elemente</h2>
      <p class="sub">Chemie Lernen — klicke ein Element, um Lernräume zu finden oder zu erstellen.</p>
      <div id="chemie-pt-grid"></div>
      <div id="chemie-pt-detail"></div>
    </div>`;
  document.body.appendChild(overlay);

  const grid = overlay.querySelector("#chemie-pt-grid");
  grid.replaceWith(buildTable());

  btn.addEventListener("click", () => overlay.classList.add("open"));
  overlay.querySelector("#chemie-pt-close").addEventListener("click", () => overlay.classList.remove("open"));
  overlay.addEventListener("click", (e) => { if (e.target === overlay) overlay.classList.remove("open"); });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
